import styled from "styled-components";

// We use a different media query since we have a fixed box size of 500px that we want to break
// before we hit
export const ONBOARDING_MEDIA_QUERY_BREAKPOINT = 550;

export const SubmitContainer = styled.div<{ $alignActionRight?: boolean }>`
  display: flex;
  justify-content: ${({ $alignActionRight }) =>
    $alignActionRight && "flex-end"};
  gap: 10px;
`;
